import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SignDetail } from '../../../../model/sign/sign-detail';
import { SignMinimal } from '../../../../model/sign/sign-minimal';
import { SignsControllerRequestService } from '../../../../services/api/signs-controller-request.service';

@Component({
  selector: 'sign-from-company-picker',
  templateUrl: './sign-from-company-picker.component.html',
  styleUrls: ['./sign-from-company-picker.component.scss']
})
export class SignFromCompanyPickerComponent implements OnChanges {
  @Input()
  sign: SignDetail;

  selectableSigns: SignMinimal[];

  isSelecting: boolean;

  searchTerm: string;

  constructor(private signsService: SignsControllerRequestService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.sign) {
      if (this.sign.pairedSign && this.sign.pairedSign.signMeasurements) {
        this.sign.pairedSign.signMeasurementsDisplay = `${this.sign.pairedSign.signMeasurements.width}x${this.sign.pairedSign.signMeasurements.height}`;
      }

      this.selectableSigns = [];
      this.isSelecting = this.sign.pairedSign == null;
      this.fetchSigns();
    }
  }

  fetchSigns(): void {
    const titleFilter: string = `title:*${this.searchTerm}*`;

    //This can be changed externally, untriggered by ngOnChanges, so can not be cached
    const companyIdsToFilter = this.sign.participatingCompanies.map(
      pc => pc.company.id
    );

    this.signsService
      .getPagedMinimal(
        companyIdsToFilter,
        titleFilter,
        'id',
        true,
        15,
        0,
        false
      )
      .then(res => {
        res.items.forEach(i => {
          if (i.signMeasurements) {
            i.signMeasurementsDisplay = `${i.signMeasurements.width}x${i.signMeasurements.height}`;
          }
        });
        this.selectableSigns = res.items;
      });
  }

  startEditing() {
    this.searchTerm = '';
    this.sign.pairedSign = null;
    this.isSelecting = true;
  }

  onSearchTermChanged(): void {
    this.fetchSigns();
  }

  public signSelected(selectedSign: SignMinimal): void {
    this.sign.pairedSign = selectedSign;
    this.isSelecting = false;
  }
}
